import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class LoadingControllerService {
  private activeLoading = new BehaviorSubject<boolean>(false);
  private message = new BehaviorSubject<string>('Ładowanie ...');

  constructor() { }

  get activeLoadingValue(): boolean {
    return this.activeLoading.getValue();
  }

  get activeLoadingStream(): Observable<boolean> {
    return this.activeLoading.asObservable();
  }

  get loadingMessage(): string {
    return this.message.getValue();
  }

  public hide(): void {
    this.activeLoading.next(false);
  }

  public show(message: string): void {
    this.message.next(this.LoadingMessage(message));
    this.activeLoading.next(true);
  }
  private LoadingMessage(message: string): string {
    if (message === 'Pobierz raport niezgodności') {
      return 'Pobieranie raportu niezgodności';
    }
    if (message === 'Pobierz zawiadomienie') {
      return 'Pobieranie zawiadomienia';
    }
    return message;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/loading-controller/loading-controller.service.ts